import { ContainerStatusEnum } from "@gtpl/shared-models/common-models";

export class ContainerSoIdRequest {
    saleOrderId?: number;


    /**
     * @param saleOrderId
    */
    constructor(saleOrderId?: number){
       this.saleOrderId=saleOrderId;
    }
}


export class ContainerStatusRequest {
    status?: ContainerStatusEnum;


    /**
     * @param status
    */
    constructor(status?: ContainerStatusEnum){
       this.status=status;
    }
}
export class componentRequest{
   component:string;
  constructor(component:string) {
        this.component = component;   

    }
}